const _this = {
    Const: {
        czf: {
            value: 1 // 操作符
        },
        sz: {
            value: 2 // 数字
        },
        kh: {
            value: 3 // 括号
        },
        xm: {
            value: 4 // 项目/工厂对象的参数
        },
        zb: {
          value: 5 // 指标
        },
        abs: {
            value: 6 // 绝对值
        }
    },
    toArray: function (str) {
        if (str.trim().length == 0) {
            return [];
        }
        var a = str.split("#|~");
        var r = [];
        a.map(function (b) {
            var bs = b.split("#_~");
            r.push({
                type: bs[0],
                key: bs[1],
                value: bs[2],
                // variable: bs[3]
            });
        });
        return r;
    },
    toStr: function (a) {
        var b = [];
        a.map(function (c) {
            b.push(c.type + "#_~" + c.key + "#_~" + c.value  );
        });
        return b.join("#|~");
    },
    arrayToDisplay: function (a) {
        var b = [];
        a.map(function (c) {
            b.push(c.value);
        });
        return b.join("");
    },
    arrayToDisplayVariable: function (a) {
        var b = [];
        a.map(function (c) {
            b.push(c.variable);
        });
        return b.join("");
    },
    arrayToDisplayScript: function (a) {
        var b = [];
        a.map(function (c) {
            if (c.type == _this.Const.xm.value) {
                // b.push("[" + c.key + "]")
                b.push("###" + c.key + "```")
            } else if(c.type == _this.Const.zb.value){
              b.push("###" + c.key + "```")
            } else {
                b.push(c.key);
            }
        });
        return b.join("");
    },
    strToDisplay: function (str) {
        var a = str.split("#|~");
        var r = [];
        a.map(function (b) {
            var bs = b.split("#_~");
            r.push(bs[2]);
        });
        return r.join("");
    },
    strToDisplayVariable: function (str) {
        var a = str.split("#|~");
        var r = [];
        a.map(function (b) {
            var bs = b.split("#_~");
            r.push(bs[3]);
        });
        return r.join("");
    },
}
export default _this 